// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bec_a bhp_rj bhp_rk bhp_vh bhp_eb bhp_vf bhp_gs bhp_kh"};